import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Card = styled.div`
  width: 520px;
  max-width: 92vw;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  color: #222;
`;

export const Header = styled.div`
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${(p) => p.color};
  color: white;
  font-weight: 600;
  button {
    background: transparent;
    border: 0;
    color: inherit;
    font-size: 22px;
    cursor: pointer;
  }
`;

export const Body = styled.div`
  padding: 14px 16px;
  display: grid;
  gap: 12px;
`;

export const Actions = styled.div`
  padding: 12px 16px 16px;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;

export const TextInput = styled.input`
  width: 100%;
  height: 36px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0 10px;
  outline: none;
  font-size: 14px;
  &:focus {
    border-color: #bbb;
  }
`;

export const ListBox = styled.div`
  border: 1px solid #eee;
  border-radius: 10px;
  max-height: 240px;
  overflow: auto;
`;

export const Row = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  cursor: pointer;
  &:nth-child(odd) {
    background: #fafafa;
  }
`;

export const Button = styled.button`
  border: none;
  border-radius: 10px;
  padding: 8px 12px;
  cursor: pointer;
  font-weight: 600;
  background: ${(p) =>
    p.kind === 'primary' ? p.color || '#ff2b80' : '#efefef'};
  color: #ffffff;
  opacity: ${(p) => (p.disabled ? 0.6 : 1)};
`;
